// Lead-magnet guides shown under /inspiration
export const GUIDES = [
  {
    slug: "5-fejl",
    tag: "5-fejl-guide",
    eyebrow: "Gratis guide",
    title: "5 fejl, smarte virksomheder undgår",
    short: "De 5 mest almindelige fejl - og hvordan I undgår dem, så jeres kommunikation rent faktisk skaber resultater",
    image: "/guides/guide-5fejl.png",
    file: "/guides/guide-5fejl.png",
    fileName: "Aicom-5-fejl-guide.png",
    intro:
      "De fleste virksomheder kommunikerer flittigt - men de færreste kommunikerer effektivt. I denne korte, konkrete guide gennemgår vi de fem mest udbredte fejl, vi ser igen og igen, og giver jer et praktisk værktøj til at rette op med det samme.",
    points: [
      "Hvorfor \"vi poster jo tit\" sjældent er nok",
      "Fejlen der får jeres budskaber til at drukne",
      "Sådan skaber I genkendelighed, der bliver husket",
      "Den tone, der får kunderne til at lytte",
      "En simpel model til at komme i gang i dag",
    ],
  },
  {
    slug: "cep",
    tag: "cep-guide",
    eyebrow: "Gratis guide",
    title: "CEP'er: Sådan bliver jeres brand husket, når kunden er klar til at købe",
    short: "Category Entry Points forklaret enkelt - og hvordan I bruger dem til at vinde flere kunder over tid.",
    image: "/guides/guide-cep.png",
    file: "/guides/guide-cep.png",
    fileName: "Aicom-CEP-guide.png",
    intro:
      "Category Entry Points (CEP'er) er de situationer, tanker og behov, der får en kunde til at overveje jeres kategori. Jo flere CEP'er jeres brand er knyttet til i kundens hukommelse, jo oftere bliver I valgt. Denne guide giver jer en enkel introduktion og en konkret metode til at arbejde med CEP'er i praksis.",
    points: [
      "Hvad CEP'er er - forklaret uden fagsprog",
      "Hvorfor mental tilgængelighed slår kortsigtede kampagner",
      "Sådan kortlægger I jeres vigtigste CEP'er",
      "Hvordan I bygger indhold, der aktiverer dem",
      "En skabelon I kan bruge med det samme",
    ],
  },
];

export const getGuide = (slug) => GUIDES.find((g) => g.slug === slug);
